import { RecordList } from "@app/models/record.model";
import { User, UserByUnit } from "@app/models/user.model";
import { Unsave } from "./data.state";

export class SetUnsave {
  static readonly type = '[Data] Set unsave List';
  constructor(public data: Unsave) { }
}

export class ClearUnsave {
  static readonly type = '[Data] Set clear List';
  constructor(public location?: string) { }
}

export class SetStaffList {
  static readonly type = '[Data] Set Staff List';
  constructor(public objectcd: string) { }
}

export class SetUserList {
  static readonly type = '[Data] Set User List';
  constructor(public objectcd: string) { }
}

export class SetUserInGroupList {
  static readonly type = '[Data] Set User In Group List';
  constructor(public objectcd: string) { }
}

export class SetStaffInTeamList {
  static readonly type = '[Data] Set Staff In Team List';
  constructor(public objectcd: string) { }
}

export class SetUserImage {
  static readonly type = '[Data] Set User Image';
  constructor(public daicd: string) { }
}
export class RemoveUserImage {
  static readonly type = '[Data] Remove User Image';
  constructor() { }
}


export class SelectUser {
  static readonly type = '[Data] Select User';
  constructor(public selectedUser?: User) { }
}

export class RemoveDataSet {
  static readonly type = '[Data] Remove User';
  constructor() { }
}

export class SetBDRoleList {
  static readonly type = '[Data] Set BDRole';
}

export class SetAllRecords {
  static readonly type = '[Data] Set All Records';
  constructor(public payload: RecordList[], public groupId?: string) { }
}

export class SetPersonalFilter {
  static readonly type = '[Data] Set persional daicd';
  constructor(public daicds: string[] = []) { }
}

export class SetCareConneRoomList {
  static readonly type = '[Data] Room List From CareConne';
  constructor(public roomListByUser: Record<string, UserByUnit>) { }
}

export class SetRenderedDataNote {
  static readonly type = '[Data] Set Rendered Data Note';
  constructor(public renderedDataNote: any) { }
}
